import { render, staticRenderFns } from "./InvestList.vue?vue&type=template&id=1b464f5e&scoped=true&"
import script from "./InvestList.vue?vue&type=script&lang=js&"
export * from "./InvestList.vue?vue&type=script&lang=js&"
import style0 from "./InvestList.vue?vue&type=style&index=0&id=1b464f5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b464f5e",
  null
  
)

export default component.exports